module.exports = __webpack_public_path__ + "material_bg.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/material_bg.png
 ** module id = 578
 ** module chunks = 0
 **/